module.exports = __webpack_public_path__ + "img/发色变换--精确识别.49ccdec1.png";